import type {CrmNodeState} from 'src/types/crm-node';


export const RECEIVE_CRM_NODE_INFO = 'crm-node/receive-info';
export const UPDATE_CRM_NODE_INFO = 'crm-node/update-info';
export const RESET_CRM_NODE_STATE = 'crm-node/reset-state';

type CrmNodePayload = Partial<CrmNodeState>;

type ReceiveCrmNodeInfoAction = {
  type: typeof RECEIVE_CRM_NODE_INFO;
  payload: CrmNodePayload;
};

type UpdateCrmNodeInfoAction = {
  type: typeof UPDATE_CRM_NODE_INFO;
  payload: CrmNodePayload;
};

type ResetCrmNodeStateAction = {
  type: typeof RESET_CRM_NODE_STATE;
};

export type CrmNodeAction =
  | ReceiveCrmNodeInfoAction
  | UpdateCrmNodeInfoAction
  | ResetCrmNodeStateAction;

export const receiveCrmNode = (
  payload: CrmNodeState,
): ReceiveCrmNodeInfoAction => ({
  type: RECEIVE_CRM_NODE_INFO,
  payload,
});

export const updateCrmNode = (
  payload: CrmNodePayload,
): UpdateCrmNodeInfoAction => ({
  type: UPDATE_CRM_NODE_INFO,
  payload,
});

export const resetCrmNode = (): ResetCrmNodeStateAction => ({
  type: RESET_CRM_NODE_STATE,
});
